@if (selectSynopticService.isSynopticGenerating()) {
    <app-loading />
}
<div
    class="content"
    [class]="synopticContentStyle()">
    @if (selectSynopticService.isLoading()) {
        <app-loading />
    } @else {
        @if (cytoscapeOptions(); as options) {
            @if (!homeService.isExternalBoxPlanPage()) {
                <div
                    class="change-deposit-select flex flex-row items-end justify-between"
                    [class.change-deposit-select--full]="isSplit()"
                    [class.hidden]="selectSynopticService.isSynopticGenerating()">
                    <div class="flex flex-row items-end gap-2 pointer-events-auto">
                        @if (
                            selectSynopticService.depositList().length > 1 ||
                            selectSynopticService.synopticZones().length > 1
                        ) {
                            <app-select-synoptic-panel />
                        }
                        <app-button
                            [label]="'export' | transloco"
                            [type]="ButtonType.SECONDARY"
                            (onClick)="
                                exportSynopticService.exportAsSvg(
                                    synopticGraphService.cy,
                                    true,
                                    selectSynopticService.selectedDeposit()!
                                )
                            " />
                    </div>
                    @if (!homeService.isExternalPage()) {
                        <app-synoptic-window-button [windowPath]="RoutePathEnum.EXT" />
                    }
                </div>
            }

            @if (selectSynopticService.selectedSynoptic()) {
                @if (!homeService.isExternalBoxPlanPage()) {
                    <div
                        class="synoptic-content"
                        [class]="synopticGraphHeightClass()"
                        [class.synoptic-content--external]="homeService.isExternalPage()">
                        <cytoscapejs
                            [autoFit]="true"
                            [cytoscapeOptions]="options"
                            (coreChanged)="doReady($event)" />
                    </div>
                }
                @if (isSynopticPlanDisplayed()) {
                    <div
                        class="boxPlan-content w-full max-w-full overflow-x-hidden"
                        [class]="synopticPlanStyle()">
                        <div class="container">
                            @if (selectSynopticService.isEditMode()) {
                                <div class="absolute top-[2px] left-36 z-50 pointer-events-none">
                                    <app-label-badge
                                        [baseIcon]="['fas', 'pen']"
                                        [label]="'synopticPlan.fiberingEditionMode' | transloco" />
                                </div>
                            }
                            <app-synoptic-plan
                                #plan
                                [cy]="synopticGraphService.cy"
                                [isLoading]="isLoadingPlan()"
                                [selectedNode]="synopticGraphService.focusedNode()!"
                                [(planItems)]="planItems"
                                (close)="close()"
                                (updateNode)="synopticGraphService.focusedNode.set($event)" />
                        </div>
                    </div>
                }
            }
        }
    }
</div>
